import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toArray, omit } from 'lodash';
import MediaQuery from 'react-responsive';

import { PATH } from '../../constants/path';
import { MENU_VERSION_MENU_MOBILE_SLIDE } from '../../services/header/constants';

import { clearFilter } from '../../services/filter/actions';
import { showSubNav, hideSubNav } from '../../services/nav/actions';
import { toggleMenuMobileSlide } from '../../services/header/actions';

import { clickEvent } from '../../utils';

import LocalizedNavLink from '../router/LocalizedNavLink';
import CategoriesSubNavComponent from './CategoriesSubNavComponent';

import './NavComponent.scss';

class MenuComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOffline: false,
            isEbon: false
        };
    }

    componentDidUpdate(prevProps) {
        const { stateOpenMenuMobileSlide, versionOpenMenuMobileSlide } = this.props;

        if (
            !prevProps.stateOpenMenuMobileSlide &&
            stateOpenMenuMobileSlide &&
            versionOpenMenuMobileSlide === MENU_VERSION_MENU_MOBILE_SLIDE
        ) {
            document.addEventListener('keydown', this.trapFocus, false);
            document.querySelector('#mobile-nav-menu-button-close').focus();
        }
        if (
            prevProps.versionOpenMenuMobileSlide === MENU_VERSION_MENU_MOBILE_SLIDE &&
            prevProps.stateOpenMenuMobileSlide &&
            !stateOpenMenuMobileSlide
        ) {
            document.removeEventListener('keydown', this.trapFocus, false);
            document.querySelector('#menu-mobile-bt').focus();
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.trapFocus, false);
    }

    trapFocus = e => {
        const focusableElements = 'button, a, [tabindex]:not([tabindex="-1"])';
        const modal = document.querySelector('#menu'); // select the modal by it's id

        const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
        const focusableContent = modal.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
        let isTabPressed = e.key === 'Tab';

        if (!isTabPressed) {
            return;
        }
        if (e.shiftKey) {
            // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else {
            // if tab key is pressed
            if (document.activeElement === lastFocusableElement) {
                // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    };

    toggleOffline = value => {
        this.setState({ isOffline: value });
    };
    toggleEbon = value => {
        this.setState({ isEbon: value });
    };

    showSubNav = subNav => this.props.showSubNav(subNav);
    hideSubNav = () => this.props.hideSubNav();

    onMouseEnterCategories = () => {};
    onMouseLeaveCategories = () => {};

    showCategories = (isOffline, isEbon) => () => {
        this.toggleOffline(isOffline);
        this.toggleEbon(isEbon);
        this.onMouseEnterCategories();
    };

    onClickBtMenuMobile = e => {
        e.preventDefault();
        this.props.toggleMenuMobileSlide(MENU_VERSION_MENU_MOBILE_SLIDE);
    };

    render() {
        const {
            i18n,
            i18nAccessibility,
            stateOpenMenuMobileSlide,
            versionOpenMenuMobileSlide,
            categories,
            location
        } = this.props;
        const { isOffline, isEbon } = this.state;
        const OnlineDirectoryUrl = `/${PATH.ONLINE}/`;
        const OfflineDirectoryUrl = `/${PATH.OFFLINE}/`;
        const EbonDirectoryUrl = `/${PATH.EBON}/`;
        const resetFilter = () => {
            this.props.clearFilter('directory');
        };
        return (
            <nav
                id="menu"
                className={`menu menu-mobile-slide ${
                    stateOpenMenuMobileSlide &&
                    versionOpenMenuMobileSlide === MENU_VERSION_MENU_MOBILE_SLIDE
                        ? 'open'
                        : 'closed'
                }`}
                role={stateOpenMenuMobileSlide ? 'dialog' : 'navigation'}
                aria-label={stateOpenMenuMobileSlide ? i18nAccessibility.MODAL_LABEL_MEMBER : ''}
                aria-modal={stateOpenMenuMobileSlide ? 'true' : 'false'}>
                <div className="menu-mobile-slide-titre bold flex-container-h flex-center-alt">
                    {i18n.TITLE}
                    <button
                        id="mobile-nav-menu-button-close"
                        className={`menu-mobile-bt menu-mobile-bt-listener show-mobonly ${
                            stateOpenMenuMobileSlide ? 'open' : 'closed'
                        }`}
                        data-target="menu"
                        onClick={this.onClickBtMenuMobile.bind(this)}>
                        <span />
                        <span className="sr-only">{i18nAccessibility.NAV_MENU_BUTTON_CLOSE}</span>
                    </button>
                </div>
                <div className="conteneur menu-conteneur flex-container-h" onClick={resetFilter}>
                    <LocalizedNavLink
                        id="nav-link-home"
                        to={PATH.HOME_PATH}
                        title={i18n.HOME}
                        activeClassName="actif"
                        onClick={clickEvent('accueil_rubrique_accueil', 'accueil')}
                        exact>
                        {i18n.HOME}
                    </LocalizedNavLink>
                    <LocalizedNavLink
                        to={PATH.HOW_IT_WORK_PATH}
                        title={i18n.HOW_IT_WORKS}
                        activeClassName="actif"
                        onClick={clickEvent('accueil_rubrique_comment_ca_marche', 'accueil')}>
                        {i18n.HOW_IT_WORKS}
                    </LocalizedNavLink>
                    <MediaQuery query="(min-width: 769px)">
                        {matches => (
                            <LocalizedNavLink
                                to={PATH.CASHBACK_ONLINE_MOST_POPULAR_PATH}
                                title={i18n.ONLINE_OFFERS}
                                className={`menu-sous-menu ${
                                    location.pathname.indexOf(OnlineDirectoryUrl) !== -1
                                        ? 'actif'
                                        : ''
                                }`}
                                onMouseEnter={this.showCategories(false, false)}
                                onMouseLeave={this.onMouseLeaveCategories}
                                onClick={clickEvent('accueil_rubrique_offres_en_ligne', 'accueil')}>
                                {i18n.ONLINE_OFFERS}
                            </LocalizedNavLink>
                        )}
                    </MediaQuery>
                    <MediaQuery query="(max-width: 768px)">
                        {matches =>
                            matches &&
                            !isOffline &&
                            !isEbon && <CategoriesSubNavComponent categories={categories} />
                        }
                    </MediaQuery>
                    <MediaQuery query="(min-width: 769px)">
                        {matches => (
                            <LocalizedNavLink
                                to={PATH.CASHBACK_EBON_MOST_POPULAR_PATH}
                                title={i18n.EBON_OFFERS}
                                className={`menu-sous-menu ${
                                    location.pathname.indexOf(EbonDirectoryUrl) !== -1
                                        ? 'actif'
                                        : ''
                                }`}
                                onMouseEnter={this.showCategories(false, true)}
                                onMouseLeave={this.onMouseLeaveCategories}
                                onClick={clickEvent(
                                    'accueil_rubrique_offres_en_bons_achat',
                                    'accueil'
                                )}>
                                {i18n.EBON_OFFERS}
                            </LocalizedNavLink>
                        )}
                    </MediaQuery>
                    <MediaQuery query="(max-width: 768px)">
                        {matches =>
                            matches &&
                            isEbon && <CategoriesSubNavComponent categories={categories} isEbon />
                        }
                    </MediaQuery>
                    <MediaQuery query="(min-width: 769px)">
                        {matches => (
                            <LocalizedNavLink
                                to={PATH.CASHBACK_OFFLINE_MOST_POPULAR_PATH}
                                title={i18n.OFFLINE_OFFERS}
                                className={`menu-sous-menu ${
                                    location.pathname.indexOf(OfflineDirectoryUrl) !== -1
                                        ? 'actif'
                                        : ''
                                }`}
                                onMouseEnter={this.showCategories(true, false)}
                                onMouseLeave={this.onMouseLeaveCategories}
                                onClick={clickEvent(
                                    'accueil_rubrique_offres_en_magasin',
                                    'accueil'
                                )}>
                                {i18n.OFFLINE_OFFERS}
                            </LocalizedNavLink>
                        )}
                    </MediaQuery>
                    <MediaQuery query="(max-width: 768px)">
                        {matches =>
                            matches &&
                            isOffline && (
                                <CategoriesSubNavComponent categories={categories} isOffline />
                            )
                        }
                    </MediaQuery>
                    <LocalizedNavLink
                        to={PATH.CONTACTREQUEST_PATH}
                        title={i18n.CONTACT}
                        activeClassName="actif"
                        onClick={clickEvent('accueil_rubrique_contact', 'accueil')}>
                        {i18n.CONTACT}
                    </LocalizedNavLink>
                </div>
                <MediaQuery query="(min-width: 769px)">
                    {matches =>
                        matches &&
                        !isOffline &&
                        !isEbon && <CategoriesSubNavComponent categories={categories} />
                    }
                </MediaQuery>
                <MediaQuery query="(min-width: 769px)">
                    {matches =>
                        matches &&
                        isEbon && <CategoriesSubNavComponent categories={categories} isEbon />
                    }
                </MediaQuery>
                <MediaQuery query="(min-width: 769px)">
                    {matches =>
                        matches &&
                        isOffline && <CategoriesSubNavComponent categories={categories} isOffline />
                    }
                </MediaQuery>
            </nav>
        );
    }
}

MenuComponent.propTypes = {
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        stateOpenMenuMobileSlide: state.header.stateOpenMenuMobileSlide,
        versionOpenMenuMobileSlide: state.header.versionOpenMenuMobileSlide,
        i18n: state.i18n.feature.header.menu,
        i18nAccessibility: state.i18n.feature.header.ACCESSIBILITY,
        categories: toArray(omit(state.category.categories, 'loading')),
        subNavDisplayed: !!state.nav.subNav,
        location: state.routing.location
    };
};

const mapDispatchToProps = {
    clearFilter,
    showSubNav,
    hideSubNav,
    toggleMenuMobileSlide
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuComponent);



// WEBPACK FOOTER //
// ./src/components/header/NavComponent.js